<template>
  <v-div
    class="FormLayout"
    :pl-3="displayIsMobile || displayIsTablet"
    :pr-3="displayIsMobile || displayIsTablet"
    float-center
    width-100-percent
  >
    <slot></slot>
  </v-div>
</template>

<script>
import {
  displayIsMobile,
  displayIsTablet,
  displayIsDesktop,
} from "~/components/utilities/displayBreakpoints";

export default {
  name: "FormLayout",
  computed: {
    displayIsMobile,
    displayIsTablet,
    displayIsDesktop,
  },
};
</script>
